import Nullstack from 'nullstack';
export default function IconBabyCarriage({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-baby-carriage",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "8",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6"
  }), "   ", Nullstack.element("path", {
    d: "M6 9h14"
  }), "   ", Nullstack.element("path", {
    d: "M9 17l1 -3"
  }), "   ", Nullstack.element("path", {
    d: "M16 14l1 3"
  }), " ");
}